<template>
<div id="ServiceRequestServiceOrderAttendant" class="fit q-px-md">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :page="page"
      @action-button="btAlterar"
    />
  </div>
</template>

<script>
import { JtCrud } from 'jtech-webcomps'
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestServiceOrderAttendantPage from './ServiceRequestServiceOrderAttendantPage'

const { CrudLayout } = JtCrud

@Component({
  name: 'ServiceRequestServiceOrderAttendant',
  components: { CrudLayout, ServiceRequestServiceOrderAttendantPage },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ServiceRequestServiceOrderAttendant extends Vue {
  get nmInterface () {
    return this.interface
  }

  get page () {
    return ServiceRequestServiceOrderAttendantPage
  }
}
export default ServiceRequestServiceOrderAttendant
</script>

<style>

</style>
